<template>
  <section class="hero text-center text-light">
    <div class="hero-bg"></div>
    <div class="hero-particles-container">
      <canvas id="hero-particles"></canvas>
    </div>
    <div class="container-sm">
      <div class="hero-inner">
        <div class="hero-copy">
          <h1 class="hero-title mt-0">
            Get a little help from our
            <span class="text-primary">Heroes</span>
          </h1>
          <p class="hero-paragraph">
            The easiest way to find a <span class="text-primary-branded">Hero</span> for the job - we put you in touch
            with the largest selection of jack-of-all-trade
            <span class="text-primary-branded">Heroes</span>, ensuring that you find the right person with the skills
            you need.
          </p>
          <div class="hero-cta">
            <a href='https://play.google.com/store/apps/details?id=com.koffeestudios.herohire&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'><img
                alt='Get it on Google Play'
                src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'
                style="width: 160px;display: inline-block"/></a>
            <a href="https://apps.apple.com/us/app/hero-hire/id1496489469">
              <img src="@/assets/app-store-badge.svg" alt="Download on the App Store">
            </a>
          </div>

          <div class="mt-32 hero-cta">
            <a href="https://app.herohire.app">
              <button class="button button-primary">
                Use Online
              </button>
            </a>
          </div>
        </div>
        <div class="mockup-container">
          <div class="mockup-bg">
            <img src="@/assets/iphone-hero-bg.svg" alt="iPhone illustration"/>
          </div>
          <img class="device-mockup" src="@/assets/herohire-iphone-01.png" alt="iPhone Hero"/>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style>
.hero-cta {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}
</style>
